import { useGrowlStoreActions } from "PFApp/stores/growl_store";
import { Modal } from "PFComponents/modal";
import { Typography } from "PFComponents/typography";
import { useResponseErrors } from "PFCore/helpers/use_response_errors";
import { useActivityHistoryInvalidate } from "PFCore/hooks/queries/activities/history/use_activity_history_invalidate";
import { requestHelp } from "PFCore/services/activity/request_help";
import { Activity, Engagement, Role } from "PFTypes";
import { useTranslation } from "react-i18next";

type RequestHelpModalProps = {
  activity: Activity | Role | Engagement;
  onClose: () => void;
};

export const RequestHelpModal = ({ activity, onClose }: RequestHelpModalProps) => {
  const { showGrowl } = useGrowlStoreActions();
  const { t } = useTranslation("activities");
  const { getFirstError } = useResponseErrors();
  const invalidateHistory = useActivityHistoryInvalidate(activity.id);

  const handleClick = () =>
    requestHelp(activity.id)
      .then(() => {
        showGrowl({ kind: "success", message: t("show.parts.helpRequested") });
        invalidateHistory();
        onClose();
      })
      .catch((error) => {
        const errorMessage = getFirstError(error);
        showGrowl({
          message: errorMessage || t("show.parts.unknownError"),
          kind: "error"
        });
      });

  return (
    <Modal
      title={t("show.parts.requestHelp")}
      labelOK={t("show.parts.requestHelp")}
      onOK={handleClick}
      onClose={onClose}
    >
      <Typography withMargin variant="bodyRegular">
        {t("show.parts.pleaseRequestHelp")}
      </Typography>
    </Modal>
  );
};
